import React from "react";
import mock05 from '../assets/images/mock05.png';
import mock06 from '../assets/images/mock06.png';
import terrorattacks from '../assets/images/terrorattacks.png';
import news from '../assets/images/newssum.png';
import traffic from '../assets/images/traffic.png';
import forestfires from '../assets/images/forestfires.png';
import '../assets/styles/Project.scss';

function Project() {
    return(
    <div className="projects-container" id="projects">
        <h1>Personal Projects</h1>
        <div className="projects-grid">
            <div className="project">
                <a href="https://github.com/MartinYTSo/forestfires" target="_blank" rel="noreferrer"><img src={forestfires} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://github.com/MartinYTSo/forestfires" target="_blank" rel="noreferrer"><h2>Predicting LA House Prices</h2></a>
                <p>Developed an app used to predict house prices from environmental risks with a 94% accuracy rate using ensemble learning, FastAPI, and Streamlit.</p>
            </div>
            <div className="project">
                <a href="https://repository.gatech.edu/entities/publication/0f1e55ce-5ac3-4641-9b5c-f0c2e555d53d" target="_blank" rel="noreferrer"><img src={terrorattacks} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://repository.gatech.edu/entities/publication/0f1e55ce-5ac3-4641-9b5c-f0c2e555d53d" target="_blank" rel="noreferrer"><h2>Detecting Terrorist Attacks Using Machine Learning</h2></a>
                <p>Applied machine learning methods to detect and analyze imminent terrorist attacks using K means clustering, SVM, logistic regression, and random forest.</p>
            </div>
            <div className="project">
                <a href="https://github.com/MartinYTSo/Mobility_Bias_Viz?tab=readme-ov-file" target="_blank" rel="noreferrer"><img src={traffic} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://github.com/MartinYTSo/Mobility_Bias_Viz?tab=readme-ov-file" target="_blank" rel="noreferrer"><h2>Unbiased Mobility Traffic Cameras</h2></a>
                <p>Analyzed traffic patterns using computer vision. Extracted data from traffic cameras using YOLOV4.</p>
            </div>
            <div className="project">
                <a href="https://github.com/MartinYTSo/ArticleSummarizer" target="_blank" rel="noreferrer"><img src={news} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://github.com/MartinYTSo/ArticleSummarizer" target="_blank" rel="noreferrer"><h2>News Article Summarizer</h2></a>
                <p>Developed a news article summarizer using Python and Tkinter .</p>
            </div>

        </div>
    </div>
    );
}

export default Project;